import React, { useContext, useEffect, useRef, useState } from 'react'

import { InfoOutlined } from '@ant-design/icons';
import { Button, Popover, Tour } from 'antd'
import { LOCAL_OPERATION_NOTIFICATION_FIRST_OPEN } from '../../helpers/Globals';

export default function DiMarketingNotificationTour({context}) {

   const [open, setOpen] = useState(false);
   
   const backLabel = "Indietro";
   const nextLabel = "Avanti";

   const {
      diAppRef,
   } = context;
  
   const steps = [
      {
         title: 'Benvenuto nella creazione della tua Notifica',
         description: 'Queste impostazioni configureranno la notifiche che la tua DylogApp invierà al tuo pubblico. Potrai visionare l\'anteprima direttamente accanto',
         target: () => diAppRef.refOperationsNotificationArea.current,
         prevButtonProps: {
            children: backLabel, 
         },
         nextButtonProps: {
            children: nextLabel,
         },
      },
      {
         title: 'Titolo',
         description: 'Inserisci il titolo della tua notifica (max 50 caratteri)',
         target: () => diAppRef.refOperationsNotificationTitle.current,
         prevButtonProps: {
            children: backLabel, 
         },
         nextButtonProps: {
            children: nextLabel,
         },
      },
      {
         title: 'Il messaggio',
         description: 'Inserisci il messaggio della tua notifica (max 300 caratteri)',
         target: () => diAppRef.refOperationsNotificationDescription.current,
         prevButtonProps: {
            children: backLabel, 
         },
         nextButtonProps: {
            children: nextLabel,
         },
      },
      {
         title: 'Scegli una pagina di atterraggio (facoltativo)',
         description: 'Puoi selezionare una pagina di atterraggio, dove l\' utente entrerà dopo aver cliccato ok al ricevimento notifica.',
         target: () => diAppRef.refOperationsNotificationAction.current,
         prevButtonProps: {
            children: backLabel, 
         },
         nextButtonProps: {
            children: "Fine",
         },
      },
   ];

   /////////////////////////////////////////////////////////////////////////////////////////// 
   // dopo la prima volta salvo che è stato aperto già in modo da non mostrare il tour //
   ///////////////////////////////////////////////////////////////////////////////////////////

   useEffect(() => {
      
      setTimeout(() => {
         setOpen(localStorage.getItem(LOCAL_OPERATION_NOTIFICATION_FIRST_OPEN) ? false : true)
         localStorage.setItem(LOCAL_OPERATION_NOTIFICATION_FIRST_OPEN, true)
      }, 1000);

   },[])
   
   /////////////////////////////////////////////////////////////////////////////////////////// 
   // dopo la prima volta salvo che è stato aperto già in modo da non mostrare il tour //
   /////////////////////////////////////////////////////////////////////////////////////////// 
  
   return (
     <>
          <Popover title="Tour della notifica">
            <Button
               onClick={() => setOpen(true)}
               icon={<InfoOutlined />}
               shape='circle'
           />
         </Popover>
         <Tour
            onClose={() => setOpen(false)}
            steps={steps}
            open={open}
         />
     </>
  )
}
